import { render, staticRenderFns } from "./GradingSystemSetup.vue?vue&type=template&id=41bf6e96&"
import script from "./GradingSystemSetup.vue?vue&type=script&lang=js&"
export * from "./GradingSystemSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports